import { IdName, PdfSettings } from './app';
import { FormFields } from './forms';
import { Tenant, TenantCore } from './tenants';

export interface JobCore extends IdName {
  description: string;
  price: number;
  jobType: IdName;
  status: JobStatus;
  scheduleDate: number;
  tenant: TenantCore;
  latitude: number;
  longitude: number;
  geocode: string;
  user?: IdName;
}

export interface CalendarJobExtendedProps {
  jobDetail: JobCore;
  source: JobCore[];
}

export interface Job extends Omit<JobCore, 'user'> {
  user: IdName;
  expenses: number;
  overprice: number;
  cost: number;
  extraData: any[];
  externalId: string;
  activities: JobActivityDetail[];
  created: number;
  pdf?: string;
  finishedDate?: number;
  deviceIds: string[];
}

export interface JobFilters {
  startDate?: number;
  endDate?: number;
  jobStatus?: number[];
  user?: IdName;
  tenant?: IdName;
  jobType?: IdName;
  paginate?: boolean;
}

export interface JobStatus {
  name?: string;
  color: string;
  statusType?: number;
}

export interface JobStatusItem {
  name: string;
  value: string;
}

export interface Skill {
  name: string;
  slug: string;
  active?: boolean;
}

export interface SkillRequestTouched {
  nameTouched: boolean;
  slugTouched: boolean;
}

export interface Schedule {
  day: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  allDay: boolean;
  startHour?: number;
  endHour?: number;
}

export interface JobType extends IdName {
  active?: boolean;
  description?: string;
  avgDuration?: number;
  cost?: number;
  technicianSkills: Skill[];
  tenants: Tenant[];
  pdfSettings: PdfSettings;
  category: JobTypeCategory;
}

export interface JobTypeRequest extends Omit<JobType, '_id' | 'tenants' | 'pdfSettings'> {
  tenants: string[];
}

export interface JobTypeRequestTouched {
  nameTouched: boolean;
  costTouched: boolean;
  avgDurationTouched: boolean;
  tenantsTouched: boolean;
  categoryTouched: boolean;
}

export enum JobTypeCategory {
  installation = 1,
  uninstall,
  revision,
  pickUp,
}

export interface JobActivityCore extends IdName {
  description?: string;
  order: number;
}

export interface JobActivity extends JobActivityCore {
  forms: IdName[];
  jobStatus: JobStatus;
  nextActivities: IdName[];
  active: boolean;
  tenants: IdName[];
}

export interface JobActivityDetail extends Omit<JobActivity, '_id' | 'tenants' | 'active' | 'forms'> {
  forms: FormFields[];
  latitude: number;
  longitude: number;
  finishedDate: number;
}

export interface JobTypeActivityRequest extends Omit<JobActivity, '_id' | 'tenants' | 'nextActivities' | 'forms'> {
  nextActivities: string[];
  forms: string[];
}

export interface JobActivityRequestTouched {
  nameTouched: boolean;
  orderTouched: boolean;
  jobStatusTouched: boolean;
}

export interface JobScheduleRequest {
  scheduleDate: string;
  userId: string;
}

export interface JobScheduleRequestTouched {
  userTouched: boolean;
  scheduleDateTouched: boolean;
}

export interface Worker {
  full_name: string;
  user_id: number;
}
